export var PaymentReminderType = /*#__PURE__*/function (PaymentReminderType) {
  PaymentReminderType["reminder"] = "reminder";
  PaymentReminderType["warn"] = "warn";
  PaymentReminderType["escalate"] = "escalate";
  return PaymentReminderType;
}(PaymentReminderType || {});
export const PaymentReminderTypeOptions = [{
  value: PaymentReminderType.reminder,
  label: 'Erinnerung'
}, {
  value: PaymentReminderType.warn,
  label: 'Warnung'
}, {
  value: PaymentReminderType.escalate,
  label: 'Blockierung'
}];
export function getPaymentReminderTypeLabel(type) {
  const match = PaymentReminderTypeOptions.find(e => e.value === type);
  if (!match) throw new Error('Invalid PaymentReminderType arg');
  return match.label;
}